import { Button } from "@mui/material";
import { Grid, GridContainer } from "src/shared/grid";

export const ModalApiGen: React.FC<any> = ({setCont, setOpenCheckModal}) => {
    const handleContinue = () =>{
        setCont(true)
    }

    const handleCancelButton = ()=>{
        setCont(false);
        setOpenCheckModal(false);

    }
    return (
        <GridContainer className="removePadding">

            <Grid row style={{padding: '3%',maxHeight: '12vh', fontSize:'18px'}} >
                {`A new API key will be generated for this user account if you continue. You must use this new API key to access the Read Only API. When a new FEMS API Code is generated, the previous code is no longer valid.`}
            </Grid>


            <Grid row className='modalBottomDiv' style={{maxHeight: '15vh'}}>
                <Grid desktop={{ col: 9 }} className="modalCancelDiv">
                    <Button variant="outlined" style={{ backgroundColor: 'white',textTransform: 'none' }} onClick={() => { handleCancelButton()}}>
                        Cancel
                    </Button>
                </Grid>
                <Grid desktop={{ col: 3 }} className='modalSubmitDiv'>

                    <Button color="primary" variant="contained" type="submit" style={{ textTransform: 'none' }} onClick={() => { handleContinue() }}>
                        Continue
                    </Button>


                </Grid>
            </Grid>
        </GridContainer>
    )
}